export const FF_CUST_KEY = 'ff';

export const ffPresetValues = {
  agentNumber1: '903681',
  firstName: 'Fonds Finanz',
  lastName: 'Maklerservice GmbH',
  company: 'Fonds Finanz Maklerservice GmbH',
  street: 'Riesstr.',
  houseNumber: '25',
  zipcode: '80992',
  city: 'München',
  email: 'kranken@fondsfinanz.de',
  phone: '089 1588150',
  mobile: '',
  remarks: 'Bei Fragen sind wir für Sie da.',
  tariffsType: ['Ambulant', 'Stationär', 'Zahn'],
};

export const ffInsurerMatch = 'Süddeutsche Krankenversicherung';
export const ffEmployeeInsurance = 'NOT_BKV';

export const ffReadOnlyFields = [
  'agentNumber1',
  'firstName',
  'lastName',
  'company',
  'street',
  'houseNumber',
  'zipcode',
  'city',
  'email',
  'phone',
  'remarks',
];

export const ffDisabledFields = [
  'tariffs',
  'gruppenvertragVertragsnummer',
  'gruppenvertragBanknummer',
  'mobile',
];
